import { Ajax } from '@shared/Ajax';

function create(parentFolderId: number, name: string, description: string): JQueryPromise<any> {
    return Ajax({
        url: `api/1/folder/create.json`,
        method: 'POST',
        data: {
            parentFolderId,
            name,
            description,
        },
    });
}

function edit(folderInfo: any): JQueryPromise<any> {
    return Ajax({
        url: `api/1/folder/edit`,
        method: 'POST',
        data: folderInfo,
    });
}

function getFilesForFolder(folderId: number): JQueryPromise<any> {
    return Ajax({
        url: `api/1/folder/${folderId}/files.json`,
    });
}

function getDetails(folderId: number): JQueryPromise<any> {
    return Ajax({
        url: `api/1/folder/${folderId}/details`,
    });
}

export const FoldersService = {
    create,
    edit,
    getFilesForFolder,
    getDetails,
};
